<template>
  <div>
    <el-drawer
      size="800px"
      :show-close="false"
      :visible="visible"
      :before-close="closeDlg"
    >
      <template slot="title">
        <div class="el-drawer-close" @click="closeDlg">
          <i class="el-icon el-icon-arrow-left"></i>返回
        </div>
        <div>{{ name }}</div>
      </template>
      <div class="drawer-content">
        <div class="table-wrap">
          <div class="action-bar" style="padding: 0 0 20px">
            <el-button type="primary" size="mini" round @click="addEval"
              >创建新评估</el-button
            >
          </div>
          <el-table
            ref="multipleTable"
            header-cell-class-name="tab-cell"
            cell-class-name="tab-cell"
            border
            :data="list.data"
            v-loading="isLoading"
            @selection-change="selectionChange"
          >
            <!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
            <el-table-column
              prop="createTime"
              label="创建时间"
            ></el-table-column>
            <el-table-column prop="finishTime" label="评估完成时间">
              <template slot-scope="scope">
                <span v-if="!scope.row.finishTime">未完成</span>
                <span v-else v-text="scope.row.finishTime"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="creatorName"
              label="创建人"
              width="150"
            ></el-table-column>

            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <div class="tab-action">
                  <el-tooltip content="查看" placement="top" :enterable="false"
                    ><i class="icon-research" @click="onView(scope.row)"></i
                  ></el-tooltip>
                  <el-popconfirm
                    confirmButtonText="删除"
                    title="确定删除吗？"
                    @confirm="delItem(scope.row)"
                  >
                    <el-tooltip
                      content="删除"
                      slot="reference"
                      placement="top"
                      :enterable="false"
                      ><i class="el-icon-delete"></i
                    ></el-tooltip>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-row>
              <el-col :span="12">
                <div class="record">
                  当前是第<span
                    v-text="(filter.pageNumber - 1) * filter.pageSize + 1"
                  ></span
                  >条至第<span
                    v-text="
                      (filter.pageNumber - 1) * filter.pageSize +
                      filter.pageSize
                    "
                  ></span
                  >数据
                </div>
                <div class="record">
                  总计<span v-text="list.total"></span>条记录
                </div>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <el-pagination
                  :disabled="isLoading"
                  layout="sizes, prev, pager, next"
                  :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                  prev-text="上一页"
                  next-text="下一页"
                  :current-page="list.current"
                  :page-size="filter.pageSize"
                  :total="list.total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                ></el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-drawer>

    <EvalDetail
      :name="name"
      :customerId="customerId"
      :id="detail.id"
      :type="type"
      :detailVisible.sync="detail.active"
      @reload="loadList"
      @viewHistory="showDlg"
    />
  </div>
</template>

<script>
// import api from '@/service/api.js';
import mixin from "@/views/mixin";
import api from "@/service/api.js";
import dayjs from "dayjs";
import EvalDetail from "./eval-detail.vue";

export default {
  components: { EvalDetail },
  mixins: [mixin],
  props: {
    visible: Boolean,
    type: Number,
    name: String,
    patientId: Number,
    customerId: Number,
    detailVisible: Boolean,
    evalId: Number,
  },
  watch: {
    visible() {
      if (this.visible) {
        this.filter.type = this.type;
        this.loadList();
      }
    },
  },
  data() {
    return {
      noSidebar: true,
      isDetailActive: false,
      detail: {
        active: false,
        id: 0,
      },
      form: {},
      list: {
        current: 1,
        total: 0,
        pageSize: 0,
        data: null,
      },
      filter: {
        customerId: 0,
        type: 0,
        pageNumber: 1,
        pageSize: 20,
      },
    };
  },
  async created() {
    if (this.$route.query.fid) {
				this.recordId = this.$route.query.fid;
        let res = await api.getInhospitalInfo(this.recordId);
        if (res.code == 500) {
          return this.$router.push({
            name: "Login",
            query: { r: location.href },
          });
        }
        this.inhospitalId = res.data.id;
			} else {
				this.recordId = '';
			}
    this.init();
  },
  methods: {
    async init() {
      this.filter.patientId = this.patientId;
      // if (this.item.resultJson && this.item.resultJson.length > 0) {
      // 	this.form = JSON.parse(this.item.resultJson);
      // }
      // this.$nextTick(async ()=>{
      // 	this.form.dictId = this.item.dictId;
      // 	this.active = true;
      // 	this.patientId = +this.$route.query.patientId;
      // });
    },
    async loadList() {
      this.isLoading = true;
      this.filter.customerId = this.customerId;
      let res = await api.getCustomerEvalList(this.filter);
      if (res.code == 500) {
        return this.$router.push({
          name: "Login",
          query: { r: location.href },
        });
      }
      this.list.total = +res.total;
      this.list.current = this.filter.pageNumber;
      this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
      if (res.data) {
        res.data.forEach((item) => {
          item.date = dayjs(item.updateTime).format("YYYY-MM-DD HH:mm:ss");
        });
        this.list.data = res.data;
      }
      this.isLoading = false;
    },
    closeDlg() {
      this.$emit("update:visible", false);
    },
    showDlg() {
      this.$emit("update:visible", true);
    },
    onView(item) {
      this.detail.active = true;
      this.detail.id = item.id;
      // this.detail.id = 31;
    },
    async addEval() {
      let res = await api.addCustomerEval({
        customerId: this.customerId,
        evalName: undefined,
        type: this.type,
        recordId:this.inhospitalId?this.inhospitalId:null,
        recordType: 1
      });
      if (res.code !== 1000) {
        this.$message.warning(res.message);
        return;
      }
      this.$message.success("创建成功");
      this.loadList();
    },
    async saveForm() {
      // let form  = this.form;
      // this.isLoading = true;
      // let res = await api.submitFollowupQuestionnaire({dataId: this.item.dataId, dictId: this.item.dictId, patientId: this.patientId, resultJson: JSON.stringify(form)});
      // this.isLoading = false;
      // if (res.code != 1000) {return this.$message.error(res.message);}
      // this.$message.success('保存成功');
      // this.$emit('update', form);
    },
    async delItem(item) {
      let res;
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      res = await api.delCustomerEval(item.id);
      if (res.code != 1000) {
        this.isLoading = false;
        return this.$message.error(res.message);
      }
      this.isLoading = false;
      this.$message({ message: "已删除", type: "success" });
      this.loadList();
    },
    handleSizeChange(v) {
      this.filter.pageSize = v;
      this.filter.pageNumber = 1;
      this.loadList();
    },
    handleCurrentChange(v) {
      this.filter.pageNumber = v;
      this.loadList();
    },
  },
};
</script>

<style lang="less" scoped>
// @import './template.less';
</style>
